import { render, staticRenderFns } from "./RenameItemModal.vue?vue&type=template&id=14470bc6&"
import script from "./RenameItemModal.vue?vue&type=script&lang=js&"
export * from "./RenameItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports